// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"735d8059","977":"2caed02d"}[chunkId] + ".chunk.js";
};